import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

import Entity from './entity';
import ModalBox from '../../../shared/modal';
import Gallery from './gallery';
import Categories from './categories';

import { getFiles, downloadZip, createZip } from './utils';

lessRequire('modules/offers/components/promo-gallery/main.less');

const isRocket = process.env.CPA_ENV === 'rocket';

const propTypes = {
	promoGalleryData: PropTypes.object,
	promoGalleryToggle: PropTypes.func,
	intl: PropTypes.func,
	promoChangeCategory: PropTypes.func,
	promoSetZipFilesSize: PropTypes.func,
	zipFilesSize: PropTypes.number
};

class PromoGallery extends React.Component {

	componentDidMount() {
		const files = getFiles(this.props.promoGalleryData.promoFilesList);
		createZip(files, blob => this.props.promoSetZipFilesSize(blob.size));
	}

	render() {
		const {
			intl,
			promoGalleryData: {
				promoForPreview,
				promoFilesList,
				shouldShowGallery,
				showedFileIndex,
				categories,
				currentCategory,
				zipFilesSize
			},
			promoGalleryToggle,
			promoChangeCategory
		} = this.props;

		return promoForPreview.main && (
			<div className="promo-container container__content">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">{intl(!isRocket ? 'Промо материалы' : 'Фото и видео материалы')}</h2>
				</div>
				{ shouldShowGallery && (
					<ModalBox
						className="modal-overlay__content promo-gallery-modal"
						body={galleryInitialize({
							title: intl(!isRocket ? 'Промо материалы' : 'Фото и видео материалы'),
							downloadTitle: intl('Скачать все одним архивом'),
							promoFilesList,
							showedFileIndex,
							categories,
							currentCategory,
							zipFilesSize
						})}
						isOpen={shouldShowGallery}
						onClose={() => promoGalleryToggle()}
						title={''}
					/>
				) }
				<div className="offer-promo-preview">
					<div className="offer-promo-preview__categories">
						{ categories.length > 1 &&  (
							<Categories categories={categories} currentCategory={currentCategory} onSelect={promoChangeCategory}/>
						) }
					</div>
					<div className="offer-promo-preview__main">
						<Entity src={promoForPreview.main} index={0} onClickAction={promoGalleryToggle}/>
					</div>
					{ !!promoForPreview.thumbs.length  && (
						<div className="offer-promo-preview__thumbs">
							{ promoForPreview.thumbs.map((file, index) => (
								<Entity src={file} key={index} index={++index} onClickAction={promoGalleryToggle} />
							)) }

							{ promoForPreview.shouldShowMore && (
								<a
									href="javascript:;"
									className="promo-thumb offer-promo__show-more"
									onClick={() => promoGalleryToggle(4)}>
									<span className="font-proxima-nova-bold">5+</span>
								</a>
							)}
						</div>
					)}
				</div>
				<a
					onClick={() => downloadZip(getFiles(promoFilesList))}
					href="javascript:;"
					className="offer-promo-download"
				>
					{`${intl(!isRocket ? 'Скачать все одним архивом' : 'Скачать архивом')}${getFileSize(zipFilesSize)}`}
				</a>
			</div>
		) || null;
	}
}

const galleryInitialize = props => {
	return <Gallery {...props} />;
};

const getFileSize = zipFileSize => zipFileSize > 0 ? `, ${zipFileSize} MB` : '';

PromoGallery.propTypes = propTypes;
export default PromoGallery;




// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/promo-gallery/main.js